var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10349_28194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 7.50033H7.50842M12.5001 12.5003H12.5084M13.3334 6.66699L6.66675 13.3337M6.11155 3.18257C6.78142 3.12912 7.41734 2.86571 7.92881 2.42984C9.12235 1.41271 10.8778 1.41271 12.0714 2.42984C12.5828 2.86571 13.2187 3.12912 13.8886 3.18257C15.4518 3.30731 16.6931 4.54861 16.8178 6.1118C16.8713 6.78166 17.1347 7.41759 17.5706 7.92905C18.5877 9.1226 18.5877 10.8781 17.5706 12.0716C17.1347 12.5831 16.8713 13.219 16.8178 13.8889C16.6931 15.452 15.4518 16.6933 13.8886 16.8181C13.2187 16.8715 12.5828 17.1349 12.0714 17.5708C10.8778 18.5879 9.12235 18.5879 7.92881 17.5708C7.41734 17.1349 6.78142 16.8715 6.11155 16.8181C4.54837 16.6933 3.30707 15.452 3.18233 13.8889C3.12887 13.219 2.86546 12.5831 2.4296 12.0716C1.41246 10.8781 1.41246 9.1226 2.4296 7.92905C2.86546 7.41759 3.12887 6.78166 3.18233 6.1118C3.30707 4.54861 4.54837 3.30731 6.11155 3.18257ZM7.91675 7.50033C7.91675 7.73044 7.7302 7.91699 7.50008 7.91699C7.26996 7.91699 7.08341 7.73044 7.08341 7.50033C7.08341 7.27021 7.26996 7.08366 7.50008 7.08366C7.7302 7.08366 7.91675 7.27021 7.91675 7.50033ZM12.9167 12.5003C12.9167 12.7304 12.7302 12.917 12.5001 12.917C12.27 12.917 12.0834 12.7304 12.0834 12.5003C12.0834 12.2702 12.27 12.0837 12.5001 12.0837C12.7302 12.0837 12.9167 12.2702 12.9167 12.5003Z",
    stroke: "#505050",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10349_28194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.500bf6c514d3243cf3f592abdfcb281d.svg";
export { ForwardRef as ReactComponent };